import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import WebsolutionsSidebar from '../../../components/WebsolutionsSidebar'
import BranddevelopmentSidebar from '../../../components/BranddevelopmentSidebar'
import DigitalmarketingSidebar from '../../../components/DigitalmarketingSidebar'

import Fill from '../../../images/Fill.svg'
import Divider from '../../../images/Divider.svg'

export const query = graphql`
  query webdesign {
    wdebanner: imageSharp(id: {regex: "/images/ClientHolder.jpg/"}) {
      sizes(quality: 75, maxWidth: 1000, traceSVG: {color: "rgb(217, 217, 217)", threshold: 75}, toFormat: PNG) {tracedSVG src}
    },
}
`

const WebsiteDesign = ({data:{wdebanner}}) => (
  <section>
    <article className='container'>
    <div className='full-Width' style={{alignItems:'flex-start'}}>
      <div className='half-Width-75 paddingRight mobBottommargin'>
        <div style={{display:'block'}}>
          <h1 className='smallerHone'>Website Design</h1>
          <img src={Divider} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/>
          <p className='smallerHone'><span className='gradient'>Case studies such as these inspire and motivate us.</span></p>
          <p>See how businesses similar to yours are growing with Digital Marketing.</p>
          <div style={{backgroundImage:`url("${wdebanner.sizes.src}"), url("${wdebanner.sizes.tracedSVG}")`, backgroundPosition:'center', backgroundSize:'cover', minHeight:'50vh', marginBottom:'1.45rem'}}>
          </div>
          <p>We design and build websites that are engaging, are user proficient, and gives the user the best insight into your brand’s business through innovative designs,
          and are up-to- date with the latest technologies.</p>
          <p style={{marginBottom:'0'}}>Whether you want a simple introductory site or a complex database driven package for the brand, we are here to provide you with the best solution and website designs.</p>
        </div>
      </div>
      <div className='half-Width-25 service-sidebar'>
        <div style={{marginBottom:'2.5rem'}}><DigitalmarketingSidebar /></div>
        <div style={{marginBottom:'2.5rem'}}><WebsolutionsSidebar /></div>
        <div><BranddevelopmentSidebar /></div>
      </div>
    </div>
    </article>
  </section>
)

export default WebsiteDesign



// WEBPACK FOOTER //
// ./src/pages/services/web-solutions/website-design.js